// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { ROUTES } from '@/constants/routes'

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-canvas px-4 text-center">
      <p className="text-8xl font-black text-brand/20 select-none mb-4">404</p>
      <h1 className="text-2xl font-bold text-ink mb-2">Page not found</h1>
      <p className="text-ink-muted mb-8 max-w-sm">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Button asChild>
        <Link to={ROUTES.DASHBOARD}>Go to dashboard</Link>
      </Button>
    </div>
  )
}
